import React from "react";
import { Link } from "react-router-dom";

export const RecentlyViewed = ({ items, excludeSlug }) => {
    const filtered = items.filter((i) => i.slug !== excludeSlug);
    if (filtered.length === 0) return null;

    return (
        <section data-testid="recently-viewed" className="container-rail py-16 border-t border-white/5">
            <div className="text-overline text-[#A3A3A3] mb-8">Recently in your eye</div>
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-x-4 gap-y-8">
                {filtered.map((p) => (
                    <Link
                        key={p.id}
                        to={`/product/${p.slug}`}
                        className="group block"
                        data-testid={`recent-${p.slug}`}
                    >
                        <div className="relative aspect-[3/4] overflow-hidden bg-[#141414] border border-white/[0.06] group-hover:border-white/20 transition-colors">
                            <img
                                src={p.image}
                                alt={p.name}
                                className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-[1.04]"
                                loading="lazy"
                            />
                        </div>
                        <div className="mt-3 flex items-start justify-between gap-2">
                            <div>
                                <div className="text-overline text-[#666] text-[9px]">{p.category}</div>
                                <div className="text-display text-base leading-tight mt-1">{p.name}</div>
                            </div>
                            <div className="text-brutal text-xs pt-0.5">${p.price}</div>
                        </div>
                    </Link>
                ))}
            </div>
        </section>
    );
};
